const restApiV1Host = process.env.REACT_APP_REST_API_V1_HOST;
const restApiV2Host = process.env.REACT_APP_REST_API_V2_HOST;
const apiHostname = restApiV2Host || restApiV1Host || "";
const protocol =
  apiHostname?.indexOf("localhost") > -1 ? "http://" : "https://";

export const apiConfig = {
  protocol,
  host: apiHostname,
  apiUrl: `${protocol}${apiHostname}`,
  graphqlPath: "/backend_gateway/graphql",
  region: process.env.REACT_APP_AWS_PROJECT_REGION,
};
